import React from "react";
import { StoreProvider } from "./Utility/Store";
import "semantic-ui-css/semantic.min.css";
import ResultContainer from "./Results/ResultContainer";
import FiltersContainer from "./Filters/FiltersContainer"

export default function MainContainer() {
  return (
    <StoreProvider>
      <div className="poc_funded_technologies_container">
      <FiltersContainer />
          <ResultContainer />
      </div>
    </StoreProvider>
  );
}
